import Message from "./message";
import Conversation from "./conversation";
import ConversationMember from "./conversation_member";

import { default as PermissionSchema } from "../../vue-ocom/grouppermissions/schema/index.js";

export default {
  Message,
  Conversation,
  ConversationMember,

  ...PermissionSchema /* For Schema */,
};
